import { Action, createReducer, on } from "@ngrx/store";
import {initialState, NetworkState} from "./network.state";
import { networkActions } from "./network.actions";
import { NetworkConnectedState } from "./network-states.enum";

let debug = false
function log(message: string) {
    if (debug) {
        console.log(message)
    }
}

export const networkReducer = createReducer(
  initialState,
    on(networkActions.socketConnected, (state, {namespace, connected}) => {
        let namespaces = [...state.sockets]
        let previousConnectedValue = state.isConnected;
        let areAllConnected = false;
        if (connected) {
            areAllConnected = state.sockets.length + 1 == 5
            const exists = namespaces.includes(namespace)
            if (!exists) namespaces.push(namespace)
        }
        if (!connected) namespaces = namespaces.filter(n => n !== namespace)
        const newState = {...state, sockets: namespaces}
        return {
            ...newState,
            allSocketsConnected: areAllConnected,
            isConnected: areAllConnected,
            previousConnectedValue: previousConnectedValue,
        }
    }),
    on(networkActions.enableNetwork, (state, { shouldEnableNetwork }) => {
        log("[Network Reducer] start network " + shouldEnableNetwork)
        return {
            ...state,
            networkEnabled: shouldEnableNetwork,
        }
    }),
    on(networkActions.markSlow, (state, { isSlow }) => {
        log("[Network Reducer] slow network " + isSlow)
        return {
            ...state,
            isSlow: isSlow,
        }
    }),
    on(networkActions.markNoResponse, (state, { isNoResponse }) => {
        log("[Network Reducer] Networking Not Responding " + isNoResponse)
        return {
            ...state,
            isNoResponse: isNoResponse,
        }
    })
);



